<template>
  <div>
    <!-- 订单报价 -->
    <baseBreadcrumb
      :page="$t('message.theOrderPrice')"
      :menu="$t('message.orderForm')"
    />
    <orderMain status="22" />
  </div>
</template>
<script>
import orderMain from "@/components/order/baseTable/index.vue";
export default {
  components: {
    orderMain,
  },
  data() {
    return {};
  },
};
</script>
<style lang='scss' scoped>
</style>